// Copyright (c) 2017 Deere & Company

import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateMachineStatusCommentsToDealer = (state, action) =>
    StatusChange.update(state, {
        commentsToDealer: {
            $set: action.comments
        }
    });

const updateMachineStatusInternalDeereComments = (state, action) =>
    StatusChange.update(state, {
        internalDeereComments: {
            $set: action.comments
        }
    });

const updateMachineStatusItemToUpdate = (state, action) =>
    StatusChange.update(state, {
        $set: action.item
    });

export default (state = getDefaultState().machineStatusItemToUpdate, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_MACHINE_STATUS_COMMENTS_TO_DEALER]: updateMachineStatusCommentsToDealer,
        [actions.UPDATE_TCSM_MACHINE_STATUS_INTERNAL_DEERE_COMMENTS]: updateMachineStatusInternalDeereComments,
        [actions.UPDATE_TCSM_MACHINE_STATUS_ITEM_TO_UPDATE]: updateMachineStatusItemToUpdate
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/machine-status-item-to-update.js